import { render, staticRenderFns } from "./PointRankingLargeText.vue?vue&type=template&id=579397c3&scoped=true&"
import script from "./PointRankingLargeText.vue?vue&type=script&lang=js&"
export * from "./PointRankingLargeText.vue?vue&type=script&lang=js&"
import style0 from "./PointRankingLargeText.vue?vue&type=style&index=0&id=579397c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579397c3",
  null
  
)

export default component.exports